// Finished rounds — ports app/(privado)/jogos/emoji/historico/page.tsx.

import { Link } from "react-router";
import { CartaoRonda } from "@/components/jogos/CartaoRonda";
import { Consulta } from "@/components/ui/EstadoConsulta";
import { useTitle } from "@/components/ui/useTitle";
import { useFinishedRounds } from "@/api/queries";
import { useSession } from "@/api/session";

export function JogosHistorico() {
  useTitle("Histórico · Jogo dos emojis");
  const query = useFinishedRounds();
  const { user } = useSession();

  return (
    <main className="mx-auto max-w-2xl px-4 py-8 sm:px-5">
      <header className="mb-6">
        <Link
          to="/jogos/emoji"
          className="text-sm text-ouro-600 hover:underline"
        >
          ← Jogo dos emojis
        </Link>
        <h1 className="mt-2 font-titulo text-3xl text-tinta-800 sm:text-4xl">
          Histórico de rondas
        </h1>
        <p className="mt-1 text-sm text-tinta-600">
          As rondas já terminadas, com todas as palavras e resultados.
        </p>
      </header>

      <Consulta query={query} linhas={2}>
        {(rondas) =>
          rondas.length === 0 ? (
            <p className="rounded-2xl border border-ouro/20 bg-creme-50 p-6 text-center text-sm text-tinta-600">
              Ainda não há rondas terminadas. Quando acabarem uma, fica aqui
              guardada. 💛
            </p>
          ) : (
            <ol className="flex flex-col gap-4">
              {rondas.map((r, i) => (
                <li key={r.round.id}>
                  <CartaoRonda
                    numero={rondas.length - i}
                    detalhe={r}
                    email={user?.email ?? null}
                  />
                </li>
              ))}
            </ol>
          )
        }
      </Consulta>
    </main>
  );
}
